import { Tutorial } from './../../model/training.model';
import { Component, Input, OnInit, EventEmitter, Output, ViewChild, ElementRef, AfterContentInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { URL_TUTORIAL_PROVIDER_ALLOWED_YOUTUBE } from '@app/@core/constants/training.constants';
import { TrainingStore } from '@app/training/services/training.store';

@Component({
  selector: 'scf-pills-tutorial-video',
  templateUrl: './pills-tutorial-video.component.html',
  styleUrls: ['./pills-tutorial-video.component.scss'],
})
export class PillsTutorialVideoComponent implements OnInit, AfterContentInit {
  @ViewChild('tutorialTitle') tutorialTitle: ElementRef;
  @Input() data: Tutorial;
  @Input() category: string = '';
  urlThumbnailVideo: string = '';

  descriptionClass = 'padding-left';

  constructor(private trainingStore: TrainingStore) {}

  ngAfterContentInit(): void {
    this.descriptionClass =
      this.tutorialTitle?.nativeElement.offsetHeight > 20
        ? 'padding-left tutorial__description--single-line'
        : 'padding-left tutorial__description--double-line';
  }

  ngOnInit() {
    if (this.data?.url) {
      if (this.trainingStore.getTutorialProvidersAllowed().filter((urlAllowed) => this.data.url.includes(urlAllowed)))
        this.getThumbnail(this.data.url, this.data.imagePath);
    }
  }

  onClickVideo = () => {
    window.open(this.data.url, '_blank');
  };

  getThumbnail = (url: string, imagePath: string) => {
    if (imagePath?.trim()) {
      this.urlThumbnailVideo = `url(assets/${imagePath})`;
    } else {
      let videoId = '';
      if (url?.includes(URL_TUTORIAL_PROVIDER_ALLOWED_YOUTUBE)) {
        videoId = this.getYouTubeId(url);
        this.urlThumbnailVideo = `url(https://img.youtube.com/vi/${videoId}/0.jpg)`;
      } else console.error('URL provided is not supported yet');
    }
  };

  getYouTubeId(url: string) {
    const arr = url.split(/(vi\/|v%3D|v=|\/v\/|youtu\.be\/|\/embed\/)/);
    return undefined !== arr[2] ? arr[2].split(/[^\w-]/i)[0] : arr[0];
  }
}
